import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import clsx from 'clsx';
import {
  BoxSeparator,
  ForbiddenSection,
  Page,
  TitleBox,
  ContentBox,
  StatusPill,
  OperationsTable,
  Tooltip
} from "../../../../../components";
import ROUTES from "../../../../../routes";
import { Language, Utils } from "../../../../../utils";
import { business as businessActions } from "../../../../../actions";
import { goBack } from "connected-react-router";
import makeClasses from "./styles";
import { Grid, Box, Hidden } from "@material-ui/core";

import { Policies } from "../../../../../utils/Policies";
import moment from "moment";
import GiftIcon from '../../../../../static/images/icons/gift-icon.svg';
import ClockIcon from '../../../../../static/images/icons/clock-icon.svg';

const CURRENCY_FILTER_OPTIONS = [
  { id: "URUGUAYAN_PESO", name: "Currency.UYU_SHORT" },
  { id: "DOLLAR", name: "Currency.USD_SHORT" },
];

const FIELD_TYPES_OPTIONS = [
  {
    id: "STRING",
    name: "ProvidersManageSubscribersRequestNewCharge.AdditionalFieldTypeOption1",
  },
  {
    id: "INTEGER",
    name: "ProvidersManageSubscribersRequestNewCharge.AdditionalFieldTypeOption2",
  },
];

const ProvidersSubscriptionsManageTransactionDetailsScreen = ({
  history,
  match,
}) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const [transaction, setTransaction] = useState(null);
  const [forbiddenSection, setForbbidenSection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  const { policies, languageTexts } = useSelector((state) => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);
  const transactionTraceId =
    match && match.params ? match.params.traceId : null;

  useEffect(() => {
    if (!policies || !policies.includes(Policies.types.PROVIDERS_SUBSCRIPTIONS_TRANSACTIONS)) {
      setForbbidenSection(true);
    }
  }, [policies]);

  useEffect(() => {
    if (!forbiddenSection) {
      loadData();
    }
  }, [forbiddenSection]);

  const loadData = () => {
    if (transactionTraceId) {
      dispatch(
        businessActions.getProvidersSubscriptionsTransactions(
          transactionTraceId,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          null,
          (data) => {
            setTransaction(data.elements?.length > 0 ? data.elements[0] : null);
          }
        )
      );
    }
  };

  const handleOnGoBackClick = () => {
    dispatch(goBack());
  };

  const handlePaginationChange = (page) => {
    setCurrentPage(page);
  };

  const renderTransactionAmount = () => {
    if (transaction.amount || transaction.amount === 0) {
      if (!transaction.promotions || transaction.promotions.length === 0) {
        return `${i18n.get(CURRENCY_FILTER_OPTIONS.find((c) => c.id === transaction.currency)?.name) || ""} ${Utils.formatCurrency(transaction.amount)}`
      }
      return <Box className={classes.amountContainer}>
        <Box className={classes.totalAmount}>{`${i18n.get(CURRENCY_FILTER_OPTIONS.find((c) => c.id === transaction.currency)?.name || "")} ${Utils.formatCurrency(transaction.subscriptionPlan.amount)}`}</Box>
        <Box className={classes.textHighlighted}>{`${i18n.get(CURRENCY_FILTER_OPTIONS.find((c) => c.id === transaction.currency)?.name || "")} ${Utils.formatCurrency(transaction.amount)}`}</Box>
     </Box>
    }
    return "-"
  };

  const renderChargesHistory = () => {
    const headers = [
      {
        canHide: false,
        columnNumber: 1,
        name: i18n.get('ProvidersSubscriptionsManageTransactionDetails.TransactionHistory.Grid.Column1'),
        sortable: false,
        type: 'date-time',
      },
      {
        canHide: false,
        columnNumber: 2,
        name: i18n.get('ProvidersSubscriptionsManageTransactionDetails.TransactionHistory.Grid.Column2'),
        sortable: false,
        type: "status"
      },
      {
        canHide: false,
        columnNumber: 3,
        name: i18n.get('ProvidersSubscriptionsManageTransactionDetails.TransactionHistory.Grid.Column3'),
        sortable: false,
        type: 'text',
      }
    ]

    const transactionHistory = transaction?.transactionHistory || [];
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedHistory = transactionHistory.slice(startIndex, endIndex);
    const hasMorePages = endIndex < transactionHistory.length;

    const body = paginatedHistory.map((item) => ({
      rowId: item.transactionTraceId,
      columns: [
        {
          columnNumber: 1,
          data: item.createdAt,
        },
        {
          columnNumber: 2,
          data: item.transactionStatus,
          customData: [
            {
              id: 'FAILED',
              label: i18n.get('Statuses.FAILED_FAILED'),
            },
        ],
        },
        {
          columnNumber: 3,
          data: item.resultMessage,
        },
      ],
    }));

    return <OperationsTable
      headers={headers}
      body={body}
      emptyMessage={i18n.get('ProvidersSubscriptionsManageTransactionDetails.TransactionHistory.GridEmptyMessage')}
      showDetails={false}
      paginationSimple={true}
      currentPage={currentPage}
      hasMorePages={hasMorePages}
      onPaginationChange={handlePaginationChange}
    />
  };

  const renderDiscount = () => {
    const isTrialPeriodPromotion = transaction.promotions.find((p) => p.promotionTrialPeriod)
    if (isTrialPeriodPromotion) {
      return  i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionTrialPeriodLabel");
    }
    return i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionDiscountLabel");
  }

  const renderPercentage = () => {
    const isTrialPeriodPromotion = transaction.promotions.find((p) => p.promotionTrialPeriod)
    if (isTrialPeriodPromotion) {
      return '100%';
    }
    return transaction.promotions[0].promotionPeriod.percentage + '%';
  }

  const renderPromotions = () => {
    const trialPeriodPromotions = transaction.promotions.filter((p) => p.promotionTrialPeriod)

     if (transaction.promotions.length === 1 || trialPeriodPromotions.length > 0) {
      return <Grid container spacing={4}>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.PromotionLabel")}:
              </div>
              <div className={classes.textHighlighted}>
                {transaction.promotions[0].name}
              </div>
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeLabel")}:
              </div>
              <div className={classes.textHighlighted}>
                {renderDiscount()}
              </div>
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionDiscountLabel")}:
              </div>
              <div className={classes.textHighlighted}>
                {renderPercentage()}
              </div>
            </div>
          </Grid>
        </Grid>
      }

    return <><Hidden smDown><Box>
      <Grid container spacing={4} className={classes.promotionHeader}>
          <Grid  item xs={12} sm={12} md={3}>
            <div>
              {i18n.get("ProvidersSubscriptionsManageTransactionDetails.NameLabel")}:
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div>
              {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeLabel")}:
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div>
              {i18n.get("ProvidersSubscriptionsManageTransactionDetails.PercentageLabel")}:
            </div>
          </Grid>
      </Grid>
      {transaction.promotions.map((promotion, index) => (
        <Grid container spacing={4} key={index} className={clsx(classes.promotionRow, index % 2 === 0 ? classes.evenRow : classes.oddRow)}>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div className={classes.textHighlighted}>
                {promotion.name}
              </div>
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div className={classes.textHighlighted}>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionDiscountLabel")}
              </div>
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div className={classes.textHighlighted}>
                {promotion.promotionPeriod ? `${promotion.promotionPeriod.percentage}%` : '100%'}
              </div>
            </div>
          </Grid>
        </Grid>
      ))}
      <Box className={classes.totalDiscountContainer}><div className={classes.discountText}>Total de porcentaje de descuento: {transaction.promotions.reduce((total, promotion) => total + (promotion.promotionPeriod ? promotion.promotionPeriod.percentage : 100), 0)}%</div></Box>
    </Box>
    </Hidden>
    <Hidden smUp>
      <Box>
      {transaction.promotions.map((promotion, index) => (
        <Grid container spacing={4} key={index} className={clsx(classes.promotionRow, index % 2 === 0 ? classes.evenRow : classes.oddRow)}>
          <Grid  item xs={12} sm={12} md={3}>
            <Grid  item xs={12} sm={12} md={3}>
              <div className={classes.suscriptionDetailsItem}>
                <div className={classes.textHighlighted}>
                  {i18n.get("ProvidersSubscriptionsManageTransactionDetails.NameLabel")}: {promotion.name}
                </div>
              </div>
            </Grid>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div className={classes.textHighlighted}>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeLabel")}: {i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionDiscountLabel")}
              </div>
            </div>
          </Grid>
          <Grid  item xs={12} sm={12} md={3}>
            <div className={classes.suscriptionDetailsItem}>
              <div className={classes.textHighlighted}>
                {i18n.get("ProvidersSubscriptionsManageTransactionDetails.PercentageLabel")}: {promotion.promotionPeriod ? `${promotion.promotionPeriod.percentage}%` : '100%'}
              </div>
            </div>
          </Grid>
        </Grid>
      ))}
      <Box className={classes.totalDiscountContainer}><div className={classes.discountText}>Total de porcentaje de descuento: {transaction.promotions.reduce((total, promotion) => total + (promotion.promotionPeriod ? promotion.promotionPeriod.percentage : 100), 0)}%</div></Box>
    </Box>
    </Hidden></>
  }

  const renderPlanName = () => {
    const name = transaction.subscriptionPlan?.code ? `${transaction.subscriptionPlan?.name} - ${transaction.subscriptionPlan?.code}` : transaction.subscriptionPlan?.name
    const hasPromotions = transaction.promotions && transaction.promotions.length > 0
    
    if (!hasPromotions) {
      return name;
    }

    const isTrialPeriodPromotion = transaction.promotions.find((p) => p.promotionTrialPeriod)
    if (isTrialPeriodPromotion) {
      return <Box className={classes.tooltipContainer}><div className={classes.textHighlighted}>{name}</div> <Tooltip title={i18n.get("ProvidersSubscriptionsManageTransactions.TrialPeriodTooltip")} >
          <img src={ClockIcon}  alt=''/>
        </Tooltip></Box>;
    }

    const isPeriodPromotion = transaction.promotions.find((p) => p.promotionPeriod)
    if (isPeriodPromotion) {
      return <Box className={classes.tooltipContainer}><div className={classes.textHighlighted}>{name}</div> <Tooltip title={i18n.get("ProvidersSubscriptionsManageTransactions.PeriodTooltip")} >
           <img src={GiftIcon}  alt=''/>
        </Tooltip></Box>;
    }

    return name;
  }

  if (forbiddenSection) {
    return (
      <Page
        withHeader
        withSidebar
        withHeaderTitle={i18n.get(
          "ProvidersSubscriptionsManageTransactionDetails.Title"
        )}
        withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}
      >
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page
      withHeader
      withSidebar
      withHeaderTitle={i18n.get(
        "ProvidersSubscriptionsManageTransactionDetails.Title"
      )}
      withActivePage={ROUTES.MANAGE_PROVIDERS_SUBSCRIPTIONS.id}
    >
      <TitleBox
        title={i18n.get(
          "ProvidersSubscriptionsManageTransactionDetails.BoxTitle"
        )}
        back
        backTitle={i18n.get(
          "ProvidersSubscriptionsManageTransactionDetails.BackButton"
        )}
        onBackClick={handleOnGoBackClick}
        backButtonVariant="outlined"
      />
      <BoxSeparator />
      {transaction ? (
        <React.Fragment>
          <ContentBox
            title={i18n.get(
              "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxDataLabel"
            )}
          >
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxDateLabel"
                    )}
                    :
                  </div>
                  {transaction.transactionDate
                    ? moment(transaction.transactionDate).format(
                        `${i18n.get("DateFormat")} ${i18n.get("TimeFormat")}`
                      )
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxPlanLabel"
                    )}
                    :
                  </div>
                  {renderPlanName()}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxBranchLabel"
                    )}
                    :
                  </div>
                  {transaction.branch ? transaction.branch?.name || "-" : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxSubscriberLabel"
                    )}
                    :
                  </div>
                  {transaction.subscriber
                    ? `${transaction.subscriber?.document || "-"} - ${
                        transaction.subscriber?.firstName || "-"
                      } ${transaction.subscriber?.lastName || "-"}`
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxCardLabel"
                    )}
                    :
                  </div>
                  {transaction.instrument
                    ? transaction.instrument.maskedPan
                    : "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxAuthorizationNumberLabel"
                    )}
                    :
                  </div>
                  {transaction.authorization || "-"}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxPlanAmountLabel"
                    )}
                    :
                  </div>
                  {renderTransactionAmount()}
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxStatusLabel"
                    )}
                    :
                  </div>
                  {transaction.transactionStatus ? (
                    <StatusPill data={transaction.transactionStatus === 'FAILED' ? 'FAILED_FAILED' : transaction.transactionStatus} />
                  ) : (
                    "-"
                  )}
                </div>
              </Grid>
              <Grid  item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                     {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeLabel"
                    )}:
                  </div>
                  <div className={classes.textHighlighted}>
                   {transaction.attempts > 0 ? i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeOptions.RetryCharge") : i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionBoxTypeOptions.InitialCharge")}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxResultMessageLabel"
                    )}
                    :
                  </div>
                  <div>
                    {transaction.resultMessage ? transaction.resultMessage : "-"}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={3}>
                <div className={classes.suscriptionDetailsItem}>
                  <div>
                    {i18n.get(
                      "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxCancellationDateLabel"
                    )}
                    :
                  </div>
                  {transaction.cancellationDate
                    ? moment(transaction.cancellationDate).format(
                        `${i18n.get("DateFormat")} ${i18n.get("TimeFormat")}`
                      )
                    : "-"}
                </div>
              </Grid>
            </Grid>
          </ContentBox>
          <BoxSeparator size="small" />
          {transaction.promotions && transaction.promotions.length > 0 && <ContentBox title={'Promociones aplicadas'}>
            {renderPromotions()}
          </ContentBox>}
          {transaction.attemps > 0 && <ContentBox title={i18n.get("ProvidersSubscriptionsManageTransactionDetails.TransactionHistory.Title")}>
            {renderChargesHistory()}
          </ContentBox>}
          {transaction.transactionPlan?.additionalFields &&
          transaction.transactionPlan?.additionalFields.length > 0 ? (
            <React.Fragment>
              <BoxSeparator size="small" />
              <ContentBox
                title={i18n.get(
                  "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxAdditionalDataLabel"
                )}
              >
                {transaction.transactionPlan?.additionalFields.map(
                  (field, key) => (
                    <Grid container spacing={4}>
                      <Grid key={key} item xs={12} sm={12} md={3}>
                        <div className={classes.suscriptionDetailsItem}>
                          <div>
                            {i18n.get(
                              "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxAdditionalDataNameLabel"
                            )}
                            :
                          </div>
                          {field.name || "-"}
                        </div>
                      </Grid>
                      <Grid key={key} item xs={12} sm={12} md={3}>
                        <div className={classes.suscriptionDetailsItem}>
                          <div>
                            {i18n.get(
                              "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxAdditionalDataInternalNameLabel"
                            )}
                            :
                          </div>
                          {field.key || "-"}
                        </div>
                      </Grid>
                      <Grid key={key} item xs={12} sm={12} md={3}>
                        <div className={classes.suscriptionDetailsItem}>
                          <div>
                            {i18n.get(
                              "ProvidersSubscriptionsManageTransactionDetails.TransactionBoxAdditionalDataTypeLabel"
                            )}
                            :
                          </div>
                          {field.type
                            ? i18n.get(
                                FIELD_TYPES_OPTIONS.find(
                                  (s) => s.id === field.type
                                ).name
                              )
                            : "-"}
                        </div>
                      </Grid>
                    </Grid>
                  )
                )}
              </ContentBox>
            </React.Fragment>
          ) : null}
        </React.Fragment>
      ) : null}
    </Page>
  );
};

ProvidersSubscriptionsManageTransactionDetailsScreen.id =
  "com.Handy.ProvidersSubscriptionsManageTransactionDetails";

export default ProvidersSubscriptionsManageTransactionDetailsScreen;
